import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CoreService, DocumentService, PortalService, RoutingService } from 'src/app/services';
import { IPortalNavigation, IUserPortalFeatures, IPortalConfig, Tools, PlatForm } from 'src/app/models';
import { Helpers } from 'src/app/helpers';
@Component({
    selector: 'medpt-portal-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class PortalLayoutComponent implements OnInit {
  sponsorName: string = "";
  portalName: string = "";
  isStudyStat: boolean =false;
  isRaiLayout: boolean = false;
  isRaspberryAI: boolean = (Helpers.getPlatformId() == PlatForm.RaspberryAI);
  constructor(
    private portalService: PortalService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private coreService: CoreService,
    private routingService: RoutingService,
    private documentService:DocumentService
  ) {
  }

  ngOnInit(): void {

    this.activatedRoute.paramMap.subscribe(params => {

      this.isStudyStat = (Helpers.getPlatformId() == PlatForm.StudyStat);
      this.isRaiLayout = this.getIsRaiLayout();
      let portalInfo = this.portalService.portalConfiguation.getValue();
      
      this.sponsorName = portalInfo.SponsorName!;
      this.portalName = portalInfo.PortalName!;
    
      this.routingService.setSponsorName(this.sponsorName);
      this.routingService.setPortalName(this.portalName);

      this.portalService.setShowPortalSection(true);
      this.portalService.setIsRaiLayout(this.isRaiLayout);
      this.portalService.setShowPortalSearch(this.router.url.split('/')[1].toLowerCase() == 'go');
      this.coreService.getUserToolNavigation(portalInfo.SponsorName, portalInfo.PortalID).then((tools: Array<Tools>) => {
        this.portalService.setToolsMenuSubject(tools);
      });
      this.coreService.getUserFeatureNavigation(<string>portalInfo.SponsorName, <number>portalInfo.PortalID).then((result: IPortalNavigation[]) => {
        this.portalService.setNavigationMenuSubject(result);

      });

      this.coreService.getUserPortalInfo(<string>portalInfo.SponsorName, <string>portalInfo.PortalName).then((result: IPortalConfig) => {
        this.portalService.setPortalDisplayName(result.DisplayName!);
        this.portalService.setPortalConfigSubject(result);
      });

      this.coreService.getAllUserFeatures(<string>portalInfo.SponsorName, <number>portalInfo.PortalID).then((result: IUserPortalFeatures[]) => {
        this.portalService.setAllFeaturesSubject(result);
      });

    });
  }

  private getIsRaiLayout(): boolean {
    const hostName = (window.location && window.location.hostname ? window.location.hostname : '').toLowerCase();
    const pathName = (window.location && window.location.pathname ? window.location.pathname : '').toLowerCase();
    const firstPathSegment = pathName.split('/').filter(x => x.length > 0)[0] || '';
    const isRaspberryAIPlatform = Helpers.getPlatformId() == PlatForm.RaspberryAI;
    const isRaspberryAIPath = pathName.indexOf('/raspberryai/') > -1;
    return hostName.startsWith('rai') || firstPathSegment == 'rai' || isRaspberryAIPlatform || isRaspberryAIPath;
  }

}
